import { useTranslate } from 'hooks/useTranslate';
import { getPartnerDetailsConfigByCorporateId } from 'modules/partners/utils/getPartnerDetailsConfigByCorporateId';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { State } from 'redux/initialState';

type Props = {
  validEmails: any;
  handleUpdatePartner: any;
};

const EditPartnerModalFooter: FC<Props> = ({
  validEmails,
  handleUpdatePartner,
}) => {
  const { t } = useTranslate();
  const actualSociety = useSelector(
    (state: State) => state.society.actualSociety
  );

  const { isPartnerEmailOptional } =
    getPartnerDetailsConfigByCorporateId(actualSociety);

  return (
    <>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-lg btn-primary "
          onClick={handleUpdatePartner}
          disabled={!validEmails() && !isPartnerEmailOptional}
        >
          {t('SaveChanges')}
        </button>
      </Modal.Footer>
    </>
  );
};

export default EditPartnerModalFooter;
